'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { createContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

export const LocationContext = createContext({
    locationFallback: {},
    isLoaded: false,
});

export const LocationProvider = ({ children }) => {
    const [renderedLocation, setUserLocation] = useState(null);

    useEffect(() => {
        async function locate() {
            try {
                const response = await fetch(
                    'https://d2k6913brarspg.cloudfront.net/geo'
                );
                setUserLocation({
                    viewerCountry: response.headers.get(
                        'cloudfront-viewer-country'
                    ),
                    viewerCountryRegion: response.headers.get(
                        'cloudfront-viewer-country-region'
                    ),
                    viewerCity: response.headers.get('cloudfront-viewer-city'),
                    viewerLat: response.headers.get(
                        'cloudfront-viewer-latitude'
                    ),
                    viewerLong: response.headers.get(
                        'cloudfront-viewer-longitude'
                    ),
                });
            } catch (e) {
                console.error(e);
            }
        }
        locate();
    }, []);

    const [locationFallback, setLocationFallback] = useState(renderedLocation);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (renderedLocation) {
            const {
                viewerCity: city,
                viewerCountry: country,
                viewerCountryRegion: state,
                viewerLat: latitude,
                viewerLong: longitude,
            } = renderedLocation;

            setLocationFallback({
                city,
                country,
                state,
                coordinates: [longitude, latitude],
                accuracy: 'fallback',
            });

            setIsLoaded(true);
        }
    }, [renderedLocation]);

    return (
        <LocationContext.Provider value={{ locationFallback, isLoaded }}>
            {children}
        </LocationContext.Provider>
    );
};

LocationContext.propTypes = {
    children: PropTypes.object.isRequired,
    location: PropTypes.shape({
        viewerCity: PropTypes.string,
        viewerCountry: PropTypes.string,
        viewerCountryRegion: PropTypes.string,
        viewerLat: PropTypes.string,
        viewerLong: PropTypes.string,
    }),
};
